/**
 * src/app/marketplace/config/providers.js
 * ---------------------------------------------------------------------------
 * Registry of marketplace app integrations. One entry per provider —
 * add a new marketplace by adding an entry here.
 * ---------------------------------------------------------------------------
 */

export const PROVIDERS = {
	quickbooks: {
		key: 'quickbooks',
		label: 'QuickBooks',
		shortLabel: 'QuickBooks',
		brandColor: '#2CA01C',
		logo: '/svg/marketplace/quickbooks/quickbooks-brand-preferred-logo-50-50-black-external.png',
		signInStartPath: '/partners/quickbooks/signin/start',
		oauthStartPath: '/partners/quickbooks/oauth/start',
		disconnectPath: '/partners/quickbooks/disconnect',
		signInButtonImage: {
			default: '/svg/marketplace/quickbooks/Sign_in_blue_btn_med_default.svg',
			hover: '/svg/marketplace/quickbooks/Sign_in_blue_btn_med_hover.svg',
			width: 161,
			height: 36,
			label: 'Sign in with Intuit'
		},
		connectButtonImage: {
			default: '/svg/marketplace/quickbooks/C2QB_green_btn_med_default.svg',
			hover: '/svg/marketplace/quickbooks/C2QB_green_btn_med_hover.svg',
			width: 223,
			height: 36,
			label: 'Connect to QuickBooks'
		}
	},
};

export const DEFAULT_PROVIDER = {
	key: 'unknown',
	label: 'your accounting software',
	shortLabel: 'your account',
	brandColor: '#140046',
	logo: null,
	oauthStartPath: null
};

export function getProvider(providerKey) {
	return PROVIDERS[providerKey] || DEFAULT_PROVIDER;
}
